var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['base-floatinput-container', ..._vm.styles]},[_c('input',_vm._g(_vm._b({attrs:{"type":"number","step":"0.01","min":"0.0","placeholder":_vm.placeholder},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }